export { CatalogTranslationSettingsPage as Component } from "./catalog-translation-settings-page"

export const CATALOG_TRANSLATION_ROUTES = {
  canonical: "/catalog-translation",
  legacySettings: "/settings/catalog-translation",
  legacySettingsRelative: "catalog-translation",
} as const
